// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Basic styling for printable documents */
.printable-container {
  font-family: 'Arial', sans-serif;
  padding: 20px;
  max-width: 900px;
  margin: auto;
  background-color: #fff;
  color: #000;
}

.printable-header {
  text-align: center;
  margin-bottom: 30px;
  border-bottom: 1px solid #ccc;
  padding-bottom: 15px;
}

.printable-header h1 {
  margin: 0 0 5px 0;
  font-size: 1.8em;
}

.printable-header p {
  margin: 2px 0;
  font-size: 1em;
  color: #333;
}

section {
  margin-bottom: 25px;
}

section h2 {
  font-size: 1.3em;
  margin-bottom: 15px;
  border-bottom: 1px solid #eee;
  padding-bottom: 5px;
  color: #111;
}

/* Summary Section */
.summary-section .summary-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 10px 20px;
  font-size: 0.95em;
  line-height: 1.5;
}

.summary-section .summary-grid div {
  padding: 5px 0;
}

.summary-section .summary-grid strong {
  color: #333;
}

/* Table Styling */
.details-table table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  font-size: 0.8em; 
  table-layout: fixed; 
}

.details-table th,
.details-table td {
  border: 1px solid #ddd;
  padding: 4px; 
  text-align: left;
  vertical-align: top;
  word-wrap: break-word;
}

.details-table th {
  background-color: #f2f2f2;
  font-weight: bold;
}

/* Column width definitions for 8 columns */
.details-table th:nth-child(1),
.details-table td:nth-child(1) { 
  width: 10%; /* Номер */
}

.details-table th:nth-child(2),
.details-table td:nth-child(2) { 
  width: 15%; /* Клиент */
}

.details-table th:nth-child(3),
.details-table td:nth-child(3) { 
  width: 8%;  /* Дата */
}

.details-table th:nth-child(4),
.details-table td:nth-child(4) { 
  width: 12%; /* Кем создан */
}

.details-table th:nth-child(5),
.details-table td:nth-child(5) { 
  width: 12%; /* Статус */
}

.details-table th:nth-child(6),
.details-table td:nth-child(6) { 
  width: 13%; /* Сумма */
}

.details-table th:nth-child(7),
.details-table td:nth-child(7) { 
  width: 13%; /* Оплачено */
}

.details-table th:nth-child(8),
.details-table td:nth-child(8) { 
  width: 13%; /* Остаток */
}

/* Right-align numeric columns */
.details-table td:nth-child(6),
.details-table td:nth-child(7),
.details-table td:nth-child(8) {
  text-align: right;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.details-table th:nth-child(6),
.details-table th:nth-child(7),
.details-table th:nth-child(8) {
  text-align: right;
}

.creator-summary-row {
  background-color: #fff !important;
  border-top: 2px solid #666;
}

.creator-summary-row td {
  font-weight: bold;
  padding: 8px 6px;
  background-color: #fff !important;
}

.summary-label {
  text-align: right !important;
  padding-right: 20px !important;
}

.grand-total-row {
  background-color: #fff !important;
  border-top: 3px double #000;
}

.grand-total-row td {
  font-weight: bold;
  padding: 10px 6px;
  font-size: 0.9em;
  background-color: #fff !important;
}

.grand-total-label {
  text-align: right !important;
  padding-right: 20px !important;
}

.spacer-row td {
  padding: 0 !important;
  border: none !important;
  background: transparent !important;
  height: 5px;
}

.status-reserved { 
  background-color: #fef3c7 !important; 
  color: #92400e !important; 
}

.status-waitingPayment { 
  background-color: #dbeafe !important; 
  color: #1e40af !important; 
}

.status-partiallyPaid { 
  background-color: #e0e7ff !important; 
  color: #3730a3 !important; 
}

.status-fullyPaid { 
  background-color: #d1fae5 !important; 
  color: #065f46 !important; 
}

.status-completed { 
  background-color: #f3f4f6 !important; 
  color: #374151 !important; 
}

.status-cancelled { 
  background-color: #fee2e2 !important; 
  color: #991b1b !important; 
}

.details-table td:nth-child(5) {
  text-align: center;
}

.details-table td:nth-child(5) span {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 9999px;
  font-size: 0.75em;
  font-weight: 600;
  text-align: center;
}

.printable-footer {
  margin-top: 40px;
  padding-top: 15px;
  border-top: 1px solid #ccc;
  text-align: center;
  font-size: 0.8em;
  color: #555;
}

/* Print-specific styles */
@media print {
  body, html, .printable-container {
    margin: 0 !important;
    padding: 10mm !important;
    width: 100% !important;
    height: auto !important;
    background: white !important;
    font-size: 10pt !important;
    line-height: 1.2 !important;
  }

  .details-table {
    width: 100% !important;
    overflow: visible !important;
  }

  .details-table table {
    width: 100% !important;
    border-collapse: collapse !important;
    font-size: 8pt !important;
    table-layout: fixed !important;
    page-break-inside: auto !important;
    break-inside: auto !important;
  }

  .details-table thead {
    display: table-header-group !important;
  }

  .details-table tfoot {
    display: table-footer-group !important;
  }

  .details-table tbody {
    display: table-row-group !important;
  }

  .order-row {
    page-break-inside: auto !important;
    break-inside: auto !important;
  }

  .creator-summary-row,
  .grand-total-row {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
  }
  .details-table th,
  .details-table td {
    border: 1px solid #000 !important;
    padding: 2px 3px !important;
    font-size: 7pt !important;
  }

  .details-table th:nth-child(1),
  .details-table td:nth-child(1) { width: 9% !important; }
  .details-table th:nth-child(2),
  .details-table td:nth-child(2) { width: 16% !important; }
  .details-table th:nth-child(3),
  .details-table td:nth-child(3) { width: 7% !important; }
  .details-table th:nth-child(4),
  .details-table td:nth-child(4) { width: 13% !important; }
  .details-table th:nth-child(5),
  .details-table td:nth-child(5) { width: 12% !important; }
  .details-table th:nth-child(6),
  .details-table td:nth-child(6) { width: 13% !important; }
  .details-table th:nth-child(7),
  .details-table td:nth-child(7) { width: 13% !important; }
  .details-table th:nth-child(8),
  .details-table td:nth-child(8) { width: 13% !important; }

  .printable-container {
    position: absolute;
    left: 0;
    top: 0;
  }
}

@media (max-width: 768px) {
  .printable-container {
    padding: 10px;
  }
  
  .details-table {
    overflow-x: auto;
    display: block;
  }
  
  .details-table table {
    min-width: 800px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/printable/PrintableOrderReport.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;EACE,gCAAgC;EAChC,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,2CAA2C;AAC3C;;EAEE,UAAU,EAAE,UAAU;AACxB;;AAEA;;EAEE,UAAU,EAAE,WAAW;AACzB;;AAEA;;EAEE,SAAS,GAAG,SAAS;AACvB;;AAEA;;EAEE,UAAU,EAAE,eAAe;AAC7B;;AAEA;;EAEE,UAAU,EAAE,WAAW;AACzB;;AAEA;;EAEE,UAAU,EAAE,UAAU;AACxB;;AAEA;;EAEE,UAAU,EAAE,aAAa;AAC3B;;AAEA;;EAEE,UAAU,EAAE,YAAY;AAC1B;;AAEA,gCAAgC;AAChC;;;EAGE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE;IACE,oBAAoB;IACpB,wBAAwB;IACxB,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;IAC5B,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,4BAA4B;EAC9B;;EAEA;IACE,sBAAsB;IACtB,oCAAoC;IACpC,yBAAyB;IACzB,8BAA8B;IAC9B,kCAAkC;IAClC,6BAA6B;EAC/B;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,kCAAkC;IAClC,6BAA6B;EAC/B;;EAEA;;IAEE,mCAAmC;IACnC,8BAA8B;EAChC;EACA;;IAEE,iCAAiC;IACjC,2BAA2B;IAC3B,yBAAyB;EAC3B;;EAEA;mCACiC,oBAAoB,EAAE;EACvD;mCACiC,qBAAqB,EAAE;EACxD;mCACiC,oBAAoB,EAAE;EACvD;mCACiC,qBAAqB,EAAE;EACxD;mCACiC,qBAAqB,EAAE;EACxD;mCACiC,qBAAqB,EAAE;EACxD;mCACiC,qBAAqB,EAAE;EACxD;mCACiC,qBAAqB,EAAE;;EAExD;IACE,kBAAkB;IAClB,OAAO;IACP,MAAM;EACR;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* Basic styling for printable documents */\n.printable-container {\n  font-family: 'Arial', sans-serif;\n  padding: 20px;\n  max-width: 900px;\n  margin: auto;\n  background-color: #fff;\n  color: #000;\n}\n\n.printable-header {\n  text-align: center;\n  margin-bottom: 30px;\n  border-bottom: 1px solid #ccc;\n  padding-bottom: 15px;\n}\n\n.printable-header h1 {\n  margin: 0 0 5px 0;\n  font-size: 1.8em;\n}\n\n.printable-header p {\n  margin: 2px 0;\n  font-size: 1em;\n  color: #333;\n}\n\nsection {\n  margin-bottom: 25px;\n}\n\nsection h2 {\n  font-size: 1.3em;\n  margin-bottom: 15px;\n  border-bottom: 1px solid #eee;\n  padding-bottom: 5px;\n  color: #111;\n}\n\n/* Summary Section */\n.summary-section .summary-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 10px 20px;\n  font-size: 0.95em;\n  line-height: 1.5;\n}\n\n.summary-section .summary-grid div {\n  padding: 5px 0;\n}\n\n.summary-section .summary-grid strong {\n  color: #333;\n}\n\n/* Table Styling */\n.details-table table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 10px;\n  font-size: 0.8em; \n  table-layout: fixed; \n}\n\n.details-table th,\n.details-table td {\n  border: 1px solid #ddd;\n  padding: 4px; \n  text-align: left;\n  vertical-align: top;\n  word-wrap: break-word;\n}\n\n.details-table th {\n  background-color: #f2f2f2;\n  font-weight: bold;\n}\n\n/* Column width definitions for 8 columns */\n.details-table th:nth-child(1),\n.details-table td:nth-child(1) { \n  width: 10%; /* Номер */\n}\n\n.details-table th:nth-child(2),\n.details-table td:nth-child(2) { \n  width: 15%; /* Клиент */\n}\n\n.details-table th:nth-child(3),\n.details-table td:nth-child(3) { \n  width: 8%;  /* Дата */\n}\n\n.details-table th:nth-child(4),\n.details-table td:nth-child(4) { \n  width: 12%; /* Кем создан */\n}\n\n.details-table th:nth-child(5),\n.details-table td:nth-child(5) { \n  width: 12%; /* Статус */\n}\n\n.details-table th:nth-child(6),\n.details-table td:nth-child(6) { \n  width: 13%; /* Сумма */\n}\n\n.details-table th:nth-child(7),\n.details-table td:nth-child(7) { \n  width: 13%; /* Оплачено */\n}\n\n.details-table th:nth-child(8),\n.details-table td:nth-child(8) { \n  width: 13%; /* Остаток */\n}\n\n/* Right-align numeric columns */\n.details-table td:nth-child(6),\n.details-table td:nth-child(7),\n.details-table td:nth-child(8) {\n  text-align: right;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.details-table th:nth-child(6),\n.details-table th:nth-child(7),\n.details-table th:nth-child(8) {\n  text-align: right;\n}\n\n.creator-summary-row {\n  background-color: #fff !important;\n  border-top: 2px solid #666;\n}\n\n.creator-summary-row td {\n  font-weight: bold;\n  padding: 8px 6px;\n  background-color: #fff !important;\n}\n\n.summary-label {\n  text-align: right !important;\n  padding-right: 20px !important;\n}\n\n.grand-total-row {\n  background-color: #fff !important;\n  border-top: 3px double #000;\n}\n\n.grand-total-row td {\n  font-weight: bold;\n  padding: 10px 6px;\n  font-size: 0.9em;\n  background-color: #fff !important;\n}\n\n.grand-total-label {\n  text-align: right !important;\n  padding-right: 20px !important;\n}\n\n.spacer-row td {\n  padding: 0 !important;\n  border: none !important;\n  background: transparent !important;\n  height: 5px;\n}\n\n.status-reserved { \n  background-color: #fef3c7 !important; \n  color: #92400e !important; \n}\n\n.status-waitingPayment { \n  background-color: #dbeafe !important; \n  color: #1e40af !important; \n}\n\n.status-partiallyPaid { \n  background-color: #e0e7ff !important; \n  color: #3730a3 !important; \n}\n\n.status-fullyPaid { \n  background-color: #d1fae5 !important; \n  color: #065f46 !important; \n}\n\n.status-completed { \n  background-color: #f3f4f6 !important; \n  color: #374151 !important; \n}\n\n.status-cancelled { \n  background-color: #fee2e2 !important; \n  color: #991b1b !important; \n}\n\n.details-table td:nth-child(5) {\n  text-align: center;\n}\n\n.details-table td:nth-child(5) span {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 9999px;\n  font-size: 0.75em;\n  font-weight: 600;\n  text-align: center;\n}\n\n.printable-footer {\n  margin-top: 40px;\n  padding-top: 15px;\n  border-top: 1px solid #ccc;\n  text-align: center;\n  font-size: 0.8em;\n  color: #555;\n}\n\n/* Print-specific styles */\n@media print {\n  body, html, .printable-container {\n    margin: 0 !important;\n    padding: 10mm !important;\n    width: 100% !important;\n    height: auto !important;\n    background: white !important;\n    font-size: 10pt !important;\n    line-height: 1.2 !important;\n  }\n\n  .details-table {\n    width: 100% !important;\n    overflow: visible !important;\n  }\n\n  .details-table table {\n    width: 100% !important;\n    border-collapse: collapse !important;\n    font-size: 8pt !important;\n    table-layout: fixed !important;\n    page-break-inside: auto !important;\n    break-inside: auto !important;\n  }\n\n  .details-table thead {\n    display: table-header-group !important;\n  }\n\n  .details-table tfoot {\n    display: table-footer-group !important;\n  }\n\n  .details-table tbody {\n    display: table-row-group !important;\n  }\n\n  .order-row {\n    page-break-inside: auto !important;\n    break-inside: auto !important;\n  }\n\n  .creator-summary-row,\n  .grand-total-row {\n    page-break-inside: avoid !important;\n    break-inside: avoid !important;\n  }\n  .details-table th,\n  .details-table td {\n    border: 1px solid #000 !important;\n    padding: 2px 3px !important;\n    font-size: 7pt !important;\n  }\n\n  .details-table th:nth-child(1),\n  .details-table td:nth-child(1) { width: 9% !important; }\n  .details-table th:nth-child(2),\n  .details-table td:nth-child(2) { width: 16% !important; }\n  .details-table th:nth-child(3),\n  .details-table td:nth-child(3) { width: 7% !important; }\n  .details-table th:nth-child(4),\n  .details-table td:nth-child(4) { width: 13% !important; }\n  .details-table th:nth-child(5),\n  .details-table td:nth-child(5) { width: 12% !important; }\n  .details-table th:nth-child(6),\n  .details-table td:nth-child(6) { width: 13% !important; }\n  .details-table th:nth-child(7),\n  .details-table td:nth-child(7) { width: 13% !important; }\n  .details-table th:nth-child(8),\n  .details-table td:nth-child(8) { width: 13% !important; }\n\n  .printable-container {\n    position: absolute;\n    left: 0;\n    top: 0;\n  }\n}\n\n@media (max-width: 768px) {\n  .printable-container {\n    padding: 10px;\n  }\n  \n  .details-table {\n    overflow-x: auto;\n    display: block;\n  }\n  \n  .details-table table {\n    min-width: 800px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
